// core version + navigation, pagination modules:
import Swiper from 'swiper/bundle';
// import Swiper and modules styles
import 'swiper/css/bundle';


/**ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー
 * Swiper function
ーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーーー*/
var topHeroSlider = new Swiper('.topHeroSlider', {
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  speed: 2000,
  preloadImages: false,

  grabCursor: true,
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: ".topHeroSlider .swiper-button-next",
    prevEl: ".topHeroSlider .swiper-button-prev",
  },
	pagination: {
		el: '.swiper-pagination',
		type: 'bullets',
		clickable: true
	},
  slidesPerView: 1, // or 'auto'
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },

});

var topWorksSlider = new Swiper('.topWorksSlider', {
  loop: true,
  centeredSlides: true,
	spaceBetween: 20,
	slidesPerView: 2,
	navigation: {
		nextEl: '.swiper-works-next',
		prevEl: '.swiper-works-prev'
	},
	pagination: {
		el: '.works-pagination',
		type: 'bullets',
		clickable: true
	},
  speed: 1500,
  // autoplay: {
  //   delay: 1500,
  //   disableOnInteraction: false,
  // },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    600: {
      slidesPerView: 4,
    },
    1200: {
      slidesPerView: 6,
    }
  }
});


